import { ModalVideo } from '../../modal-video/modal-video';

export class CardTemoignage {
  constructor() {
    this.init();
  }

  private init(): void {
    const buttons = document.querySelectorAll('.card-temoignage__play');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const youtubeUrl = (button as HTMLElement).dataset.youtubeUrl;
        if (youtubeUrl) {
          const modal = ModalVideo.getInstance();
          modal.openYoutube(youtubeUrl);
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CardTemoignage());
} else {
  new CardTemoignage();
}
